import { render, staticRenderFns } from "./CrossroadItem.vue?vue&type=template&id=a51e137a"
import script from "./CrossroadItem.vue?vue&type=script&lang=ts"
export * from "./CrossroadItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports